import React, { useEffect, useRef, useState } from 'react';
import AudioPlayer from '../AudioPlayer/AudioPlayer';
import LoadMoreButton from './LoadMoreButton';
import useEpisodePlayersContext from "../../hooks/useEpisodePlayersContext";

const EpisodeList = ({ perView }) => {
    const { data, setClickedButtonIndex, setNextVideoPlay } = useEpisodePlayersContext();
    const audioRefs = useRef([]);
    const startAndLoadVisibleItems = perView ? parseInt(perView) : 5;
    const [visibleItems, setVisibleItems] = useState(startAndLoadVisibleItems);

    const handleClick = (episodeIndex) => {
        setClickedButtonIndex(episodeIndex);
    };

    const pauseAll = (active) => {
        audioRefs.current.forEach((audioRef) => {
            if (audioRef && audioRef.current) {
                audioRef.current.pause();
                if (!active) audioRef.current.currentTime = 0; // comment if you want to leave current state time
            }
        });
    };

    const play = (id) => {
        if (id < visibleItems) {
            setNextVideoPlay(id);
        } else {
            viewMore();
            setTimeout(function () {
                setNextVideoPlay(id);
            }, 1000);
        }
    };

    const viewMore = () => {
        setVisibleItems((prevVisibleItems) => prevVisibleItems + startAndLoadVisibleItems);
    };

    useEffect(() => {
        return () => {
            pauseAll();
        };
    }, []);

    return (
        <div className="App player-app">
            <ul className="player-app__list">
                {data?.episodes?.slice(0, visibleItems)?.map((episode, episodeIndex) => {
                    audioRefs.current[episodeIndex] = audioRefs.current[episodeIndex] || React.createRef();
                    return (
                        data?.episodes[episodeIndex]?.episodeSrc && (
                            <li className="player-app__item" key={episodeIndex}>
                                <AudioPlayer
                                    play={play}
                                    episodeIndex={episodeIndex}
                                    ref={audioRefs.current[episodeIndex]}
                                    handleClick={() => handleClick(episodeIndex)}
                                />
                            </li>
                        )
                    );
                })}
            </ul>
            {visibleItems < data?.episodes?.length && <LoadMoreButton viewMore={viewMore} />}
        </div>
    );
};
export default EpisodeList;
